<template>
    <v-card>
        <v-card-title class="white--text" :style="{background: appColors.primary1}">
            <div class="headline">Ny {{roleName(userRole).toLowerCase()}}</div>
        </v-card-title>
        <v-card-text class="px-3 pt-3">
            <v-form ref="form">
                <v-text-field dense filled v-model="email"  tabindex="1" label="brukernavn (e-post)*" :rules="[v => !!v && !!v.trim() || 'påkrevd', v => /.+@.+\..+/.test(v) || 'ugyldig e-post']"></v-text-field>
                <v-text-field dense filled v-model="firstname" tabindex="2" label="fornavn*" :rules="[v => !!v && !!v.trim() || 'påkrevd']"></v-text-field>
                <v-text-field dense filled v-model="lastname" tabindex="3" label="etternavn*" :rules="[v => !!v && !!v.trim() || 'påkrevd']"></v-text-field>
                <v-text-field dense filled v-model="mobile" tabindex="4" label="mobil*" :rules="[v => !!v && !!v.trim() || 'påkrevd', v => /\+?\d{8,}/.test(v) || 'ugyldig mobilnummer']"></v-text-field>

                <v-text-field dense filled tabindex="5" v-model="password" label="passord*" :type="showPassword ? 'text':'password'" :append-icon="passwordIcon" @click:append="togglePasswordIcon" :rules="[v => !!v && !!v.trim() || 'påkrevd']"></v-text-field>
                <v-text-field dense filled tabindex="6" v-model="retypePassword" label="gjenta passord*" :type="showPassword ? 'text':'password'" :append-icon="passwordIcon" @click:append="togglePasswordIcon" :rules="[v => !!v && !!v.trim() || 'påkrevd', v => v === password || 'passord og gjenta passord ulik']"></v-text-field>

                <brreg tabindex="7" @organisation="organisationChange" :registrationNumber="registrationNumber"></brreg>
            </v-form>
        </v-card-text>
        <v-card-actions class="px-3 pb-3">
            <slot name="returnLink"></slot>
            <v-spacer></v-spacer>
            <v-btn @click="addUser" tabindex="8" color="green white--text">
                <v-icon left>mdi-plus</v-icon>
                {{okText || 'legg til'}}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { Role } from "../utilities/enums";
import { colors as appColors } from "../utilities/colors";

export default {
    props: ["userRole", "okText", "registrationNumber"],
    data() {
        return {
            appColors,
            email: null,
            firstname: null,
            lastname: null,
            mobile: null,
            password: null,
            retypePassword: null,
            showPassword: false,
            passwordIcon: "mdi-eye",
            organisation: null
        };
    },
    computed: {},
    watch: {
        password() {
            this.$refs.form.validate();
        },
        retypePassword() {
            this.$refs.form.validate();
        }
    },
    methods: {
        async addUser() {
            if (this.$refs.form.validate() && this.organisation) {
                // debugger;
                let userDTO = {
                    email: this.email.trim().toLowerCase(),
                    firstname: this.firstname.trim(),
                    lastname: this.lastname.trim(),
                    mobile: this.mobile.trim(),
                    role: this.$props.userRole
                };

                try {
                    let newUSer = await this.$store.dispatch("registerUser", { user: userDTO, password: this.password, registrationNumber: this.organisation.registrationNumber });
                    this.$emit("newUser", newUSer);
                } catch (error) {
                    // console.log(error);
                    // debugger;
                    this.$store.commit("snackbar", { show: true, text: "Brukernavn er i bruk", color: "error" });
                }
            }
        },
        roleName(role) {
            switch (role) {
                default:
                case Role.USER: {
                    return "Bruker";
                }
                case Role.MAINUSER: {
                    return "Hovedbruker";
                }
                case Role.REVISOR: {
                    return "Revisor";
                }
                case Role.SUPERUSER: {
                    return "Superbruker";
                }
            }
        },
        togglePasswordIcon() {
            this.showPassword = !this.showPassword;
            if (this.showPassword) {
                this.passwordIcon = "mdi-eye-off";
            } else {
                this.passwordIcon = "mdi-eye";
            }
        },
        organisationChange(organisation) {
            this.organisation = organisation;
        }
    }
};
</script>

<style lang="scss" scoped>
</style>